import React from 'react'
import { Box, Typography } from '@material-ui/core'
import type { UnpaidCharge } from '../../hooks/useMoveOutManagement/useMoveOutManagement'
import { formatCurrency, formatDate } from './utils'

interface UnpaidChargeCardProps {
    charge: UnpaidCharge
}

export const UnpaidChargeCard: React.FC<UnpaidChargeCardProps> = ({
    charge,
}) => {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            style={{
                padding: '12px 16px',
                borderBottom: '1px solid #f1f5f9',
            }}
        >
            <Box>
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                    {charge.charge_code_name}
                </Typography>
                {charge.description && (
                    <Typography variant="body2" color="textSecondary">
                        {charge.description}
                    </Typography>
                )}
                {charge.transaction_date && (
                    <Typography variant="caption" color="textSecondary">
                        {formatDate(charge.transaction_date)}
                    </Typography>
                )}
            </Box>
            <Typography
                variant="body2"
                style={{
                    fontWeight: 600,
                    color: '#ef4444',
                    whiteSpace: 'nowrap',
                    marginLeft: 16,
                }}
            >
                {formatCurrency(parseFloat(charge.amount))}
            </Typography>
        </Box>
    )
}
